/// <reference path='../_all.ts' />

module glossar {
  'use strict';

  export class GlossaryEntry {
    constructor(
      public GlossaryID: number,
      public Title: string,
      public IndexLetter: string,
      public Content: string,
      public Active: boolean
      ) { }
  }
}